import { useEffect, useRef, useState } from "react"
import { useLocation } from "react-router-dom"

import { cn } from "styles/utils"

import DesktopNav from "./desktop-nav"
import MicroBanner from "./micro-banner"
import MobileHeader from "./mobile-header"

const HeaderContent = () => {
  const [sticky, setSticky] = useState(false)
  const headerRef = useRef()
  const rafRef = useRef()
  const location = useLocation()

  useEffect(() => {
    const handleScroll = () => {
      rafRef.current = window.requestAnimationFrame(() => {
        if (headerRef.current) {
          setSticky(
            !location.pathname.includes("cart") &&
              window.pageYOffset >
                headerRef.current.getBoundingClientRect().height + 50
          )
        }
      })
    }

    window.addEventListener("scroll", handleScroll)
    return () => {
      window.cancelAnimationFrame(rafRef.current)
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <header
      className={cn(
        "backface-hidden duration-400 sticky top-0 z-50 flex w-full flex-col bg-white transition-shadow",
        sticky ? "shadow-lg" : "shadow-none",
        location.pathname.includes("cart") && "tablet:static"
      )}
      ref={headerRef}
    >
      <MicroBanner />
      <MobileHeader />
      <DesktopNav />
    </header>
  )
}

export default HeaderContent
